import BaseCtrl from 'edge/platform/base/BaseCtrl';
/**
 * Sets a typeke value to a first one.
 *
 * @param {Object} model
 */
function setToDefault(model) {
    if (!model.value) {
        model.value = model.aspects.availableValues[0];
    }
}

var fn = function fn($scope, submissionViewModel) {
    var submissionVm = submissionViewModel();

    var ctrl = Object.create(BaseCtrl);
    // const defaultVisibleFields = ['Fam1', 'Fam2', 'TownRow', 'Mobile'];

    ctrl.init = function () {
        $scope.view = submissionVm.lobData.homeowners.coverables.yourHome;
        $scope.view.value = $scope.view.value || {};

        setToDefault($scope.view.dwellingLocation);
        setToDefault($scope.view.residenceType);
        setToDefault($scope.view.dwellingUsage);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'submissionViewModel'];
export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/ho/controllers/HOYourHomeCtrl.js
// module id = 2152
// module chunks = 0